import { useMemo } from "react";

import { EBroadcastStatus, type TGetBroadcastStatusResponse, broadcastAPI } from "@api/broadcast";
import { processRequest } from "@api/config";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

const broadcastStatusDataInitial = {
	id: "",
	startedAt: 0,
	isOnline: false,
	isAwayMode: false,
	broadcastAwayModeStatus: "",
	broadcastAwayModeStatusMessage: "",
	broadcastTextStatus: "",
	broadcastStatus: EBroadcastStatus.OFFLINE,
	broadcastMembersCount: 0,
	broadcastDurationSec: 0,
	lastBroadcast: 0,
	is2DStreamActive: false,
	is3DStreamActive: false,
	hasMask: false,
	privateInfo: null,
};

export const getBroadcastStatusData = async (): Promise<TGetBroadcastStatusResponse> => {
	const data = await processRequest({
		prefix: API_PREFIXES.GET_BROADCAST_STATUS_DATA,
		request: (token) => broadcastAPI.broadcastStatusAsync({ token }),
	});

	return data;
};

export const useBroadcastStatusDataQuery = () => {
	const query = useAuthQuery({
		queryKey: [QUERY_KEYS.BROADCAST_STATUS_DATA],
		queryFn: getBroadcastStatusData,
	});

	const data = query.isSuccess ? query.data : broadcastStatusDataInitial;

	return useMemo(
		() => ({
			...data,
			isLoading: query.isLoading,
			isFetching: query.isFetching,
			isSuccess: query.isSuccess,
		}),
		[data, query.isFetching, query.isLoading, query.isSuccess],
	);
};
